/**
 * The profile reply rate bound.
 * The number is a percentage.
 */
export const REPLY_RATE_BOUND = 75

export const hasPositiveReplyRate = (replyRate?: number) => {
  return typeof replyRate !== 'undefined' && replyRate >= REPLY_RATE_BOUND
}
